import React from 'react';
import classNames from 'classnames';
import { useToastStore, hideToast, Toast as ToastType } from '@jwp/ott-common/src/stores/ToastStore';
import SuccessIcon from '@jwp/ott-theme/assets/icons/check_circle.svg?react';
import InfoIcon from '@jwp/ott-theme/assets/icons/info-fill.svg?react';
import CloseIcon from '@jwp/ott-theme/assets/icons/close.svg?react';

import Icon from '../Icon/Icon';

import styles from './Toast.module.scss';

const ToastItem = ({ toast }: { toast: ToastType }) => {
  const getIcon = () => {
    switch (toast.type) {
      case 'success':
        return SuccessIcon;
      case 'error':
        return InfoIcon;
      case 'info':
        return InfoIcon;
      default:
        return InfoIcon;
    }
  };

  return (
    <div
      className={classNames(styles.toast, styles[toast.type], {
        [styles.show]: toast.visible,
        [styles.hide]: !toast.visible,
      })}
    >
      <div className={styles.icon}>
        <Icon icon={getIcon()} />
      </div>
      <p className={styles.message}>{toast.message}</p>
      <button className={styles.closeButton} onClick={() => hideToast(toast.id)}>
        <Icon icon={CloseIcon} />
      </button>
    </div>
  );
};

const Toast = () => {
  const toasts = useToastStore((state) => state.toasts);

  if (toasts.length === 0) {
    return null;
  }

  return (
    <div className={styles.toastContainer}>
      {toasts.map((toast) => (
        <ToastItem key={toast.id} toast={toast} />
      ))}
    </div>
  );
};

export default Toast;
